import '../i18n'

import type { LeadSlice } from '../model/slice'

import { LeadDetailSheet } from './lead-detail-sheet'
import { LeadsTable } from './leads-table'

type CampaignLeadsPanelProps = {
  campaignId: string
  slice: LeadSlice
  onSliceChange: (patch: Partial<LeadSlice>) => void
  page: number
  leadId: string | undefined
  onPageChange: (page: number) => void
  pageSize: number
  onPageSizeChange: (pageSize: number) => void
  onSelect: (leadId: string | undefined) => void
}

/**
 * The log scoped to one campaign, for the campaign's own leads view.
 *
 * No period picker here: the counters above already carry one, and it drives
 * both halves — one window per screen.
 */
export function CampaignLeadsPanel({
  campaignId,
  slice,
  onSliceChange,
  page,
  leadId,
  onPageChange,
  pageSize,
  onPageSizeChange,
  onSelect,
}: CampaignLeadsPanelProps) {
  return (
    <>
      <LeadsTable
        campaignId={campaignId}
        slice={slice}
        onSliceChange={onSliceChange}
        page={page}
        onPageChange={onPageChange}
        pageSize={pageSize}
        onPageSizeChange={onPageSizeChange}
        onSelect={onSelect}
      />
      <LeadDetailSheet leadId={leadId} onClose={() => onSelect(undefined)} />
    </>
  )
}
